import script from "./InvoiceSection2b.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection2b.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection2b.vue?vue&type=style&index=0&id=172ab022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172ab022"]])

export default __exports__